import * as types from './actionTypes';

const config = window.weftConfig;
const apiRoot = config.CMS_URL + '/api';


function handleErrors(response, infoText) {
  if (!response.ok) {
    return response.text().then(text => {
      console.log(`Error response in ${infoText}: ${response.status} ${response.statusText}`, text);
      return Promise.reject({
        status: response.status,
        statusText: response.statusText,
        text: text
      });
    });
  } else {
    return response;
  }
}


/*
 *   Fetch collab content
 */

function getCollabData() {
  return {
    type: types.GET_COLLAB_DATA,
    isFetching: true,
  };
}

function receiveCollabData(data) {
  return {
    type: types.RECEIVE_COLLAB_DATA,
    isFetching: false,
    data,
  };
}

function getCollabDataError(error) {
  return {
    type: types.GET_COLLAB_DATA_ERROR,
    isFetching: false,
    error,
  };
}

export function fetchCollabData(collab_slug=null) {
  let collabEndpoint = collab_slug ? `/collab-artist/${collab_slug}/` : '/collab-artist/';
  return (dispatch, getState) => {
    dispatch(getCollabData());
    return fetch(apiRoot + collabEndpoint, { credentials: 'include' })
      .then(response => handleErrors(response, 'fetchCollabData'))
      .then(data => data.json())
      .then(body => {
        dispatch(receiveCollabData(body));
      })
      .catch(err => dispatch(getCollabDataError(err)));
  };
}